import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addToCartItems, fetchCartItemsByUserId, updateCartItemsByUserId, removeCartItemsByUserId } from "./Cart_API";

const initialState = {
    items: [],
    itemsLength: null,
    status: "idle"
}

export const addCartItemsAsync = createAsyncThunk(
    'cart/addToCartItems',
    async (item) => {
        const response = await addToCartItems(item);
        return response;
    }
)

export const fetchCartItemsByUserIdAsync = createAsyncThunk(
    'cart/fetchCartItemsByUserId',
    async () => {
        const response = await fetchCartItemsByUserId();
        return response;
    }
)

export const updateCartItemsByUserIdAsync = createAsyncThunk(
    'cart/updateCartItemsByUserId',
    async (updateData) => {
        const response = await updateCartItemsByUserId(updateData);
        return response;
    }
)

export const removeCartItemsByUserIdAsync = createAsyncThunk(
    'cart/removeCartItemsByUserId',
    async (cartid) => {
        const response = await removeCartItemsByUserId(cartid);
        if (response?.status === "success") {
            return { status: "success", message: cartid }
        }
    }
)


export const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        resetCartSlice: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(addCartItemsAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addCartItemsAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                //If item is already exist with same id then we will update the quantity instead of add new
                if (state.items?.some(item => item.id === action.payload.id)) {
                    state.items = state.items.map(item => item.id === action.payload.id ? action.payload : item);
                } else {
                    state.items.push(action.payload);
                }

                state.itemsLength = state.items?.length;
            })
            .addCase(fetchCartItemsByUserIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCartItemsByUserIdAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.items = action.payload;
                state.itemsLength = state.items?.length;
            })
            .addCase(updateCartItemsByUserIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateCartItemsByUserIdAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload?.status === "success") {
                    state.items = state.items.map(item => item.id === action.payload.message.id ? action.payload.message : item)
                    state.itemsLength = state.items?.length;
                }
            })
            .addCase(removeCartItemsByUserIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(removeCartItemsByUserIdAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';

                if (action.payload?.status === "success") {
                    state.items = state.items.filter(item => item.id !== action.payload.message)
                    state.itemsLength = state.items?.length;
                }
            })
    }


})

export const { resetCartSlice } = cartSlice.actions;

//selector
export const isLoadingCart = (state) => state.cart.status === 'loading';

export default cartSlice.reducer;